import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from "@/components/common/ui/Button.tsx";
import { usePasswordReset } from '@/hooks/auth/usePasswordReset';

const AuthSuccess: React.FC = () => {
    const { clearResetSession } = usePasswordReset();
    const navigate = useNavigate();

    const handleReturnToLogin = () => {
        clearResetSession();
        navigate('/auth/login');
    };

    return (
        <div className="space-y-6">
            {/* Success Icon with Animation */}
            <div className="flex justify-center">
                <div className="relative">
                    <div className="absolute inset-0 bg-green-100 dark:bg-green-900/30 rounded-full animate-ping opacity-20" />
                    <div className="relative h-16 w-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
                        <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
                    </div>
                </div>
            </div>

            {/* Success Message */}
            <div className="text-center space-y-2">
                <h1 className="text-2xl font-bold font-grotesk text-text-primary-light dark:text-text-primary-dark">
                    Password Reset Successful
                </h1>
                <p className="text-text-secondary-light dark:text-text-secondary-dark font-roboto max-w-sm mx-auto">
                    Your password has been successfully updated. You can now sign in with your new password.
                </p>
            </div>

            {/* Action Button */}
            <div className="space-y-4">
                <Button
                    onClick={handleReturnToLogin}
                    fullWidth
                    size="lg"
                >
                    Return to Login
                </Button>

                <div className="text-center">
                    <Link
                        to="/contact"
                        className="text-sm text-text-muted-light dark:text-text-muted-dark hover:text-text-secondary-light dark:hover:text-text-secondary-dark transition-colors duration-200 font-roboto"
                    >
                        Having trouble? Contact support
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AuthSuccess;